module.exports = __webpack_public_path__ + "img/icon4.2a0ad357.png";